import React, { useState, useEffect, useImperativeHandle, forwardRef, useMemo  } from "react";
import {

    Box,
    Card,
    CardActionArea,
    CircularProgress,
    Divider,
    Grid,
    Stack,
    Skeleton,
    Typography,
    Button,
    Fab
} from "@mui/material";
import debounce from 'lodash.debounce';
import { ContractAssignor } from "src/app/models/contract-assignor";
import { SvgCard } from "../../../shared/SvgCard/SvgCard";
import { Auth } from 'src/app/models/auth';
import { useAppDispatch, useAppSelector } from "src/app/react/hooks/redux";
import { editCollaboratorValue, getCollaboratorsValues, summaryOldValueRebalance } from "src/app/react/redux/collaborator/actions";
import { updateValuesPurchase } from "src/app/react/redux/purchase/actions";
import { Table, InputNumber } from 'antd';
import { formatPrice } from '../../../shared/utils';
import { getPurchaseSummary } from "src/app/react/redux/purchase/actions";
import { SummaryItems } from "src/app/react/models/purchase/summary-purchase.model";
import { SummaryPurchase } from "../Summary/Summary";
import { getOverlappingDaysInIntervals } from "date-fns";
import { CollaboratorResponse } from "src/app/react/models/collaborator/collaborator-response.model";
import { Product } from "src/app/react/models/product/product-response.model";

interface ValuesPurchaseProps {
  purchaseType: number;
  purchaseOption: number;
  productsId?: number[]
}

const { Column } = Table

let currentPage = 1;
let limit = 10;

export const ValuesPurchase = forwardRef(({ purchaseType, purchaseOption, productsId }: ValuesPurchaseProps, ref) => {

    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));

    const dispatch = useAppDispatch();

    const { purchase, summary, summaryLoading, loading: purchaseLoading } = useAppSelector(state => state.purchase);
    const { products } = useAppSelector(state => state.product);
    const { products: productsOfGroup  } = useAppSelector(state => state.group);
    const { collaborators, editedCollaborators, error, loading, oldValue } = useAppSelector(state => state.collaborator);
    const [ selectedProducts, setSelectedProducts ] = useState<Product[]>([]);
    const [ selectedProductIndex, setSelectedProductIndex ] = useState<number>(0);
    const filteredProducts = products?.filter(x=> purchaseType !== 1 ? productsId.includes(x.productId) : productsOfGroup.includes(x.productId));
    const [ selectedProduct, setSelectedProduct ] = useState<number>(filteredProducts[0].productId);


    useEffect(() => {      
      currentPage = 1;

      setSelectedProduct(filteredProducts[0].productId);
      setSelectedProducts(filteredProducts);
      fetchCollaboratorsValues(currentPage, limit, selectedProduct);
    },[])
    
    useEffect(() => {
    }, [oldValue])

    useEffect(() => {
    }, [selectedProduct, selectedProductIndex, selectedProducts])

    useImperativeHandle(ref, () => ({
      handleValuesPurchase
    }));

    const fetchCollaboratorsValues = (page: number, limit: number, productId: number) => {
      dispatch(getCollaboratorsValues(currentUser.token.assignorGuid, currentUser.token.userReferenceId, limit, page, productId, purchase));
    }

    const handleValuesPurchase = () => {
      handleSummaryCalculation();
      editedCollaborators.purchaseId = purchase;
      dispatch(updateValuesPurchase(currentUser.token.assignorGuid, currentUser.token.userReferenceId, editedCollaborators));
    }

    const handleSelectCard = (productId: number, index: any) => {
      handleSummaryCalculation();
      
      setSelectedProduct(productId);
      setSelectedProductIndex(index);
      currentPage = 1;

      fetchCollaboratorsValues(currentPage, limit, productId);
    }

    const onInputChange = (collaboratorId, providedValue) => {
      dispatch(editCollaboratorValue(selectedProduct, collaboratorId, providedValue));
    };

    const handleTableChange = (pagination:any) => {
      handleSummaryCalculation();
      currentPage = pagination.current;
      limit = pagination.pageSize;
      dispatch(getCollaboratorsValues(currentUser.token.assignorGuid, currentUser.token.userReferenceId, pagination.pageSize, pagination.current, selectedProduct, purchase))
    };

    const handleSummaryCalculation = () => {
      let newValue = 0;
      collaborators.items.map((collaborator: CollaboratorResponse) => {
          newValue = newValue + collaborator.providedValue;
      })
      dispatch(getPurchaseSummary(currentUser.token.assignorGuid, currentUser.token.userReferenceId, purchase, selectedProduct, oldValue, newValue, summary));
      dispatch(summaryOldValueRebalance(newValue));      
    }

    return (
    <>

      <Grid container spacing={1} key="grid01">
        <Grid item xs={9} className="p-3">
            <Stack
              key="productsStack"
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
            >
              {purchaseLoading &&
                <>
                  <Skeleton variant="rectangular" width={260} height={130}></Skeleton>
                  <Skeleton variant="rectangular" width={200} height={100}></Skeleton>
                  <Skeleton variant="rectangular" width={200} height={100}></Skeleton>
                </>
              }
              {selectedProducts.map((product: Product, index: any) => {
                if(index === selectedProductIndex) {
                  return (
                    <Card sx={{ maxWidth: 260 }} key={index}>
                        <SvgCard
                            key={'icon'+index}
                            color={product?.productColor}
                            icon={product?.productIcon}
                            label={product?.productDescription}
                        ></SvgCard>
                    </Card>
                  )
                }

                return (
                  <Card sx={{ maxWidth: 200 }} key={index}>
                    <CardActionArea disabled={summaryLoading} onClick={() => handleSelectCard(product?.productId, index)}>
                      <SvgCard
                          key={'icon'+index}
                          color={product?.productColor}
                          icon={product?.productIcon}
                          label={product?.productDescription}
                      ></SvgCard>
                    </CardActionArea>
                  </Card>
                  )
              })}
            </Stack>
            <Box className="mt-5">
              <Table
                dataSource={collaborators.items}
                loading={loading}
                rowKey="collaboratorId"
                pagination={{
                    position: ["bottomRight"],
                    current: currentPage,
                    defaultPageSize: limit,
                    total: collaborators?.totalItems,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '25', '50', '100'],
                    locale: { items_per_page: "" },
                }}
                onChange={handleTableChange}
              >
                <Column
                    title="Nome"
                    dataIndex="name"
                    key="name"
                />
                <Column
                    title="CPF"
                    dataIndex="document"
                    key="document"
                />
                <Column
                    title="Matrícula"
                    dataIndex="register"
                    key="register"
                />
                <Column
                    title="Valor de Referência"
                    dataIndex="standardValue"
                    render={(text: any, record: any, index: number) => (
                      <InputNumber
                        prefix="R$"
                        id={record.collaboratorId}
                        name="standardValue"
                        value={record.standardValue}
                        formatter={value => value.toString().replace('.', ',')}
                        parser={value => value.replace(',', '.')}
                        onChange={(e) => onInputChange(record.collaboratorId, e)}
                        controls={false}
                        min={0}
                        style={{ width: '75%' }}/>
                    )}
                />
                <Column
                    title="Valor a ser Disponibilizado"
                    dataIndex="providedValue"
                    render={(text: any, record: any) => (
                      <InputNumber
                        id={record.collaboratorId}
                        name="providedValue"
                        value={formatPrice(text)}
                        style={{ width: '75%', color: '#000', cursor: 'pointer' }}
                        disabled={true}/>
                    )}
                />
              </Table>
            </Box>
        </Grid>
        <Grid item xs={3} className="p-0">
          <SummaryPurchase products={purchaseType !== 1 ? productsId : productsOfGroup} handleSummaryCalculation={handleSummaryCalculation}/>
        </Grid>
      </Grid>
    </>
  );
});


